import React, { useEffect, useState, FC, useRef } from "react";
import style from "./index.module.scss";
import { Menu, Form, Button, Input, Breadcrumb, Spin, Tabs, Radio, Table } from "antd";
import qs from 'qs';
import * as Type from "../../config";
export interface IAppProps {
  apiHost: string;
  loginHost: string;
}
const { TabPane } = Tabs;
let _host = "";
let _loginHost = "";
const { SubMenu, Item } = Menu;
const titleMap = {
  1: "授权工具",
  2: "签名工具",
  3: "权限查询",
  4: "云鼎IP查询",
  5: "Token有效期查询",
  6: "API日志排查工具",
};

const sidebarList = [
  {
    title: "授权工具",
    id: 1,
  },
  {
    title: "签名工具",
    id: 2,
  },
  {
    title: "权限查询",
    id: 3,
  },
  {
    title: "云鼎IP查询",
    id: 4,
  },
  {
    title: "Token有效期查询",
    id: 5,
  },
  {
    title: "API日志排查工具",
    id: 6,
  },
];

const columns = [
  {
    title: 'IP地址',
    dataIndex: 'ip',
    key: 'ip'
  },
  {
    title: '是否为云鼎内IP',
    dataIndex: 'isYdIp',
    key: 'isYdIp',
    render: (text: any, record: any) =>{
      return record.isYdIp ? "是" : "否"
    }
  }
];

const tokencolumns = [
  {
    title: 'Token',
    dataIndex: 'token',
    key: 'token'
  },
  {
    title: '被授权应用',
    dataIndex: 'appKey',
    key: 'appKey',
    render: (text: any, record: any) =>{
      return <div>
        <div>{record.appName}</div>
        <div>{record.appKey}</div>
      </div>
    }
  },
  {
    title: '授权起始时间',
    dataIndex: 'startOauthTime',
    key: 'startOauthTime',
  },
  {
    title: '授权终止时间',
    dataIndex: 'endOauthTime',
    key: 'endOauthTime',
  }
];

/**
 *
 * @param name 下划线转驼峰
 */
const toHump = (name: any) => {
  return name.replace(/_(\w)/g, function (_all: any, letter: any) {
    return letter.toUpperCase();
  });
};

/**
 *
 * 将url转换成对象
 * @param url
 *
 */
const urlToObject = (url: any) => {
  const urlObject: any = {};
  if (/\?/.test(url)) {
    const objs = qs.parse(url.split('?')[1]);
    Object.keys(objs).map(k => {
      switch (k) {
        case "360buy_param_json":
          urlObject.paramJson = objs[k];
          break;
        case "v":
          urlObject.version = objs[k];
          break;
        case "timestamp":
          urlObject.timeStamp = objs[k];
          break;
        default:
          urlObject[toHump(k)] = objs[k];
      }
    })
    return urlObject;
  }
};

const mustKey = ["appKey", "method", "paramJson", "timeStamp", "version"];
const formListKey = [
  {
    label: "签名工具",
    type: "radio",
    required: true,
    key: "signMethod",
    placeholder: "",
    emptyError: "请选择签名类型",
    initialValue: "md5",
    list: [
      {
        key: "md5",
        label: "md5",
      },
      {
        key: "hmacmd5",
        label: "hmacmd5",
      },
      {
        key: "hmacsha256",
        label: "hmacsha256",
      },
    ],
    rules: [],
  },
  {
    label: "access_token",
    type: "input",
    required: true,
    key: "accessToken",
    placeholder: "采用OAuth授权方式是必填参数",
    rules: [],
  },
  {
    label: "app_key",
    type: "input",
    required: true,
    key: "appKey",
    placeholder: "请填写应用的app_key，示例：E6C7BECADB2D8FFCCACABB0D35158C2A ",
    rules: [
      {
        required: true,
        message: "请填写应用的app_key",
      },
    ],
  },
  {
    label: "app_secret",
    type: "input",
    required: true,
    key: "appSecret",
    placeholder: "请填写应用的app_secret，示例：6cc6e03e44b5499eab657af559aaddb8",
    rules: [
      {
        required: true,
        message: "请填写应用的app_secret",
      },
    ],
  },
  {
    label: "method",
    type: "input",
    required: true,
    key: "method",
    placeholder: "请填写API接口名称，示例：jingdong.getUserLevel.query",
    rules: [
      {
        required: true,
        message: "请填写API接口名称",
      },
    ],
  },
  {
    label: "timestamp",
    type: "input",
    required: true,
    key: "timeStamp",
    placeholder: "时间戳，格式为yyyy-mm-dd hh:mm:ss",
    emptyError: "请填写时间戳",
    rules: [
      {
        required: true,
        message: "请填写时间戳",
      },
    ],
  },
  {
    label: "360buy_param_json",
    type: "input",
    required: true,
    key: "paramJson",
    placeholder: '请输入json格式，示例：{"end_date": "2012-05-16 17:03:56"}',
    emptyError: "请输入json格式",
    rules: [
      {
        required: true,
        message: "请输入json格式",
      },
      {
        validator: (_rule, value, callback) => {
          const tmp: any = urlToObject(value) || {};
          let isValid = true;

          if (value) {
            try {
              JSON.parse(value);
            } catch (error) {
              isValid = false;
            }

            if (!isValid) {
              callback("请输入json格式");
            }
          }
          callback();
        },
      },
    ],
  },
  {
    label: "V",
    type: "input",
    required: false,
    key: "version",
    placeholder: "API协议版本，参考接口文档版本，示例：1.0",
    rules: [
      {
        required: true,
        message: "请填写API协议版本",
      },
    ],
  },
];

const formListUrl = [
  {
    label: "请求URL",
    type: "textarea",
    required: true,
    key: "url",
    name: "url",
    placeholder: "请填写已拼接好的请求URL",
    rules: [
      {
        required: true,
        message: "请填写已拼接好的请求URL",
      },
      {
        validator: (_rule, value, callback) => {
          const tmp: any = urlToObject(value) || {};
          let isValid = true;
          if (value) {
            mustKey.map((k: string) => {
              if (!tmp[k]) {
                isValid = false;
              }
            });
            if (!isValid) {
              callback("输入参数不全，无法计算签名");
            }
          }
          callback();
        },
      },
    ],
  },
  {
    label: "app_secret",
    type: "input",
    required: true,
    key: "appSecret",
    name: "appSecret",
    placeholder: "请填写应用的app_secret，示例：6cc6e03e44b5499eab657af559aaddb8",
    rules: [
      {
        required: true,
        message: "请填写应用的app_secret",
      },
    ],
  },
];

const LeftContentWrap: React.FC<any> = (props: any) => {
  return (
    <div className={style.leftContentWrap}>
      <header className={style.title}>常用工具</header>
      <Menu
        defaultSelectedKeys={props.selectKeys}
        defaultOpenKeys={props.selectKeys}
        className={style.menuWrap}
        mode={"inline"}
        theme={"light"}
        inlineIndent={20}
        style={{ paddingLeft: 0 }}
      >
        {sidebarList.map((item: any) => {
          return (
            <Item
              key={item.id}
              title={item.title}
              onClick={() => {
                window.location.href = window.location.pathname + "?id=" + item.id;
              }}
            >
              <div className={style.selectedItem}>{item.title}</div>
            </Item>
          );
        })}
      </Menu>
    </div>
  );
};

const MainContentWrapFc: FC<any> = (props: any) => {
  const { crumbList, mainTitle, nameKey = "channelName" } = props;
  return (
    <div className={style.mainContentWrap}>
      <header className={style.headerTitle}>
        <Breadcrumb>
          <Breadcrumb.Item>{mainTitle}</Breadcrumb.Item>
          {crumbList &&
            crumbList.map((o: any) => {
              return (
                <Breadcrumb.Item key={o.id}>
                  <a href="">{o[nameKey]}</a>
                </Breadcrumb.Item>
              );
            })}
        </Breadcrumb>
      </header>
      {props.children}
    </div>
  );
};

const Auth: FC<any> = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    setLoading(true);
    fetch(_host + "/josTools/manualAuth?appKey=" + values.appKey, {
      method: "GET",
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res.code === 99999) {
          window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
        } else if (res.code === 200 || res.code === 500) {
          setResult({
            ...res,
            success: false,
          });
        } else {
          setResult({
            ...res,
          });
        }
      })
      .catch(function () {
        console.log("失败了！！！");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className={style.authWrap}>
      <div className={style.desContentWrap}>
        <div className={style.desTitleWrap}>授权工具使用说明：</div>
        <div className={style.desItemWrap}>1. 用于自研商家使用，请您使用商家账号登录后进行授权。</div>
        <div className={style.desItemWrap}>2. 输入AppKey，点击授权，即将该pin对应店铺的数据授权给该AppKey。</div>
      </div>
      <div className={style.formWrap}>
        <Spin spinning={loading}>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="AppKey"
              name="appKey"
              rules={[
                {
                  required: true,
                  message: "请输入您要授权的AppKey",
                },
              ]}
            >
              <Input placeholder={"请输入您要授权的AppKey"} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                授权
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
      {result ? (
        <div className={style.resultWrap}>
          <div className={style.resultTitleWrap}>授权结果</div>
          <div className={style.resultContentWrap}>
            {result.success ? (
              <div>
                <div>{result.message}</div>
                <div>
                  <span>token：</span>
                  <span>{result.data.access_token}</span>
                </div>
                <div>
                  <span>token有效期：</span>
                  <span>{result.data.expires_in}</span>
                </div>
                <div>
                  <span>refresh token：</span>
                  <span>{result.data.refresh_token}</span>
                </div>
              </div>
            ) : (
              <div>
                <div>授权失败～</div>
                <div>{result.message}</div>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

const Sign: FC<any> = () => {
  const [loading, setLoading] = useState(false);
  const [canComputed, setCanComputed] = useState(true);
  const [result, setResult] = useState(null);
  const [form] = Form.useForm();
  const [formUrl] = Form.useForm();
  const [queryType, setQueryType] = useState("1");
  const [signMethod, setSignMethod] = useState("md5");

  // 计算结果
  const onFinish = (values: any) => {
    setLoading(true);
    let queryParam: any = {};
    if (queryType === "2") {
      const obj = urlToObject(values.url);
      queryParam = {
        ...obj,
        appSecret: values.appSecret,
      };
    } else {
      queryParam = {
        ...values,
      };
    }

    setSignMethod(queryParam.signMethod);
    const formParam = new FormData();
    Object.keys(queryParam).forEach(function (key) {
      const item = encodeURIComponent(queryParam[key]);

      if (item) {
        formParam.append(key, item);
      }
    });

    fetch(_host + "/josTools/signTool", {
      method: "POST",
      body: formParam,
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res.code === 99999) {
          window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
        } else {
          setCanComputed(false);
          setResult({
            ...res.data,
          });
        }
      })
      .catch(function () {
        return console.log("失败了！！！");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const ItemWrap = ({ label, value }) => {
    return (
      <div className={style.resultItemWrap}>
        <span className={style.itemLabelWrap}>{label}</span>
        <span className={style.itemValueWrap}>{value}</span>
      </div>
    );
  };
  const ResultCard = ({ title, item }) => {
    const arr = [
      {
        label: "1、解析参数：",
        value: item.paramAnalysis.map((v) => {
          return <div key={v}>{v}</div>;
        }),
      },
      {
        label: "2、参数排序：",
        value: item.paramSort,
      },
      {
        label: "3、拼接参数：",
        value: item.paramAppend,
      },
      {
        label: `4、${signMethod ? signMethod.toUpperCase() : 'MD5'}加密后转大写，生成签名：`,
        value: item.sign,
      },
      {
        label: "5、生成HTTP请求URL：",
        value: item.httpRequestUrl,
      },
    ];
    return (
      <div className={style.resultContentWrap}>
        <div className={style.signToolResultTitle}>{title}</div>
        {arr.map((v) => {
          return <ItemWrap key={v.label} label={v.label} value={v.value}></ItemWrap>;
        })}
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      form.resetFields();
    }, 10000);
  }, []);

  return (
    <div className={style.signWrap}>
      <div className={style.desContentWrap}>
        <div className={style.desItemWrap}>
          <a href="https://jos.jd.com/commondoc?listId=530" target="_blank" rel="noopener noreferrer">
            查看说明文档
          </a>
        </div>
      </div>
      <div className={style.formWrap}>
        <Spin spinning={loading}>
          <Tabs
            defaultActiveKey="1"
            onChange={(v) => {
              setQueryType(v);
              setCanComputed(true);
              setResult(null);
              form.resetFields();
              formUrl.resetFields();
            }}
          >
            <TabPane tab="按字段输入" key="1">
              <Form
                layout="vertical"
                onFinish={onFinish}
                form={form}
                initialValues={{
                  signMethod: "md5",
                }}
              >
                {formListKey.map((item: any) => {
                  return (
                    <Form.Item key={item.key} name={item.key} label={item.label} rules={item.rules}>
                      {item.type === "input" && (
                        <Input
                          placeholder={item.placeholder}
                          onChange={(e: any) => {
                            setCanComputed(true);
                            form.setFieldsValue({
                              [item.key]: e.target.value,
                            });
                          }}
                        />
                      )}
                      {item.type === "radio" && (
                        <Radio.Group
                          defaultValue={item.initialValue}
                          onChange={(e: any) => {
                            setCanComputed(true);
                            form.setFieldsValue({
                              [item.key]: e.target.value,
                            });
                          }}
                        >
                          {item.list.map((v: any) => {
                            return (
                              <Radio key={v.key} value={v.key}>
                                {v.label}
                              </Radio>
                            );
                          })}
                        </Radio.Group>
                      )}
                    </Form.Item>
                  );
                })}
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={!canComputed}>
                    计算结果
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>
            <TabPane tab="按URL输入" key="2">
              <Form layout="vertical" onFinish={onFinish} form={formUrl}>
                {formListUrl.map((item: any) => {
                  return (
                    <Form.Item key={item.key} name={item.name} label={item.label} rules={item.rules}>
                      {item.type === "input" && (
                        <Input
                          placeholder={item.placeholder}
                          onChange={(e: any) => {
                            setCanComputed(true);
                            formUrl.setFieldsValue({
                              [item.name]: e.target.value,
                            });
                          }}
                        />
                      )}
                      {item.type === "textarea" && (
                        <Input.TextArea
                          placeholder={item.placeholder}
                          rows={5}
                          onChange={(e: any) => {
                            setCanComputed(true);
                            formUrl.setFieldsValue({
                              [item.name]: e.target.value,
                            });
                          }}
                        />
                      )}
                    </Form.Item>
                  );
                })}
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={!canComputed}>
                    计算结果
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>
          </Tabs>
        </Spin>
      </div>
      {result ? (
        <div className={style.resultWrap}>
          <div className={style.resultTitleWrap}>计算结果</div>
          {result.auth ? <ResultCard title={"授权接口"} item={result.auth} key="auth"></ResultCard> : null}
          {result.unAuth ? <ResultCard title={"非授权接口"} item={result.unAuth} key="unAuth"></ResultCard> : null}
        </div>
      ) : null}
    </div>
  );
};

const AuthApiListFc: FC<any> = (props) => {
  const [currentId, setId] = useState<number>(null);
  const [apiPage, setApiPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [apiAuthList, setApiAuthList] = useState([]);

  const fetchApiAuthList = (id) => {
    if (id) {
      fetch(`${_host}/api/listOwnedAuthPackage?josApiId=${id}&page=${apiPage}`)
        .then((o) => o.json())
        .then((response) => {
          const { code, data, extData } = response;
          if (code === 100000) {
            setApiAuthList(apiAuthList.concat(data));
            const ex = extData ? parseInt(extData) : 0;
            setTotalPage(ex);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    setId(props.id);
    fetchApiAuthList(props.id);
  }, [props.id]);

  useEffect(() => {
    fetchApiAuthList(currentId);
  }, [apiPage]);

  const column = [
    {
      title: "拥有此API的权限包",
      dataIndex: "authPackageName",
      key: "authPackageName",
      // eslint-disable-next-line react/display-name
      render: (text, record) => {
        return (
          <a
            href={`/apilist?apiGroupId=${record.authPackageId}&apiGroupName=${record.authPackageName}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {text}
          </a>
        );
      },
    },
    {
      title: "可获得/可申请该API权限包的应用类型",
      dataIndex: "appTypeNames",
      key: "appTypeNames",
    },
  ];
  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          如何获取该API
        </div>
      </div>
      {totalPage > 0 ? (
        <a
          href="https://jos-console.jd.com/#/app/index"
          target="_blank"
          className={style.jumpLink}
          rel="noopener noreferrer"
        >
          前往控制台创建应用
        </a>
      ) : null}

      <div className={style.api_auth_package_wrap}>
        <Table
          columns={column}
          rowKey={"authPackageId"}
          rowClassName={style.table_row_class}
          pagination={false}
          dataSource={apiAuthList}
        />
        {apiPage > 0 && apiPage < totalPage ? (
          <a
            className={style.search_more}
            onClick={() => {
              setApiPage(apiPage + 1);
            }}
          >
            查看更多
          </a>
        ) : null}
      </div>
    </section>
  );
};
const AuthQuery: FC<any> = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    setLoading(true);
    fetch(_host + "/josTools/isHasAcl?appKey=" + values.appKey + "&apiName=" + values.apiName, {
      method: "GET",
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res && res.code === 99999) {
          window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
        } else {
          setResult({
            ...res,
          });
        }
      })
      .catch(function () {
        console.log("失败了！！！");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className={style.authQueryWrap}>
      <div className={style.desContentWrap}>
        <div className={style.desTitleWrap}>权限查询工具使用说明：</div>
        <div className={style.desItemWrap}>用于查询接口是否已有调用权限。</div>
      </div>
      <div className={style.formWrap}>
        <Spin spinning={loading}>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="AppKey"
              name="appKey"
              rules={[
                {
                  required: true,
                  message: "请填写AppKey",
                },
                {
                  validator: (_rule, value, callback) => {
                    if (value) {
                      if (!/^[0-9a-zA-Z]+$/.test(value)) {
                        callback("AppKey格式不正确哦~应为英文或阿拉伯数字格式");
                      }
                      callback();
                    }

                    callback();
                  },
                },
              ]}
            >
              <Input placeholder={"请输入您要授权的AppKey"} />
            </Form.Item>
            <Form.Item
              label="Method"
              name="apiName"
              rules={[
                {
                  required: true,
                  message: "请输入您要查询的接口名称",
                },
              ]}
            >
              <Input placeholder={"请输入您要查询的接口名称"} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>

      {result ? (
        <div className={style.resultWrap}>
          <div className={style.resultTitleWrap}>权限查询结果</div>
          <div className={style.resultContentWrap}>
            <div>{result && result.message}</div>
          </div>
          {result.data && result.data.code === 5 ? (
            <div>
              <AuthApiListFc id={result.data.id}></AuthApiListFc>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const YunQuery: FC<any> = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [form] = Form.useForm();
  const [yunList, setYunList] = useState([]);
  const onFinish = (values: any) => {
    setShow(true)
    let arr = values.IP.split(',')
    let formData = new FormData()
    console.log(arr);
    formData.append("ips",arr)
    setLoading(true);
    fetch(_host + "/josTools/checkYdIp", {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res && res.code === 99999) {
          console.log(res);
          window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
        } else {
          setResult({
            ...res,
          });
          setYunList(res.data);
        }
      })
      .catch(function () {
        console.log("失败了！！！");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className={style.authQueryWrap}>
      <div className={style.desContentWrap}>
        <div className={style.desTitleWrap}>云鼎IP查询工具使用说明：</div>
        <div className={style.desItemWrap}>为方便您快捷查询您的IP是否已入云鼎，特提供此工具。</div>
      </div>
      <div className={style.formWrap} >
        <Spin spinning={loading}>
          <Form layout="vertical" onFinish={onFinish} form={form}>
            <Form.Item
              label="IP地址"
              name="IP"
              initialValue=""
              rules={[
                {
                  required: true,
                  message: "请填写IP地址~"
                },
                {
                  validator: (_rule, value, callback) => {
                    let arr = value.split(',')
                    console.log(arr, 'arr', arr.length);
                    if (arr.length > 100) {
                      callback("超出最大长度");
                    }
                    callback();
                  }
                }
              ]}
            >
              <Input placeholder={"请输入您要查询的IP地址，多个IP请用英文逗号隔开，最多可输入100个"} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>

      <div style={{ display: show ? "block" : "none"  }}>
        <div className={style.desContentWrap}>
          <div className={style.YunDing}>查询结果</div>
        </div>
        <div className={style.TableToken}>
          <Table
            bordered
            dataSource={yunList}
            columns={columns}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

const TokenQuery: FC<any> = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [form] = Form.useForm();
  const [tokenList, setTokenList] = useState<any>({});
  const onFinish = (values: any) => {
    setShow(true)
    const arr = values.token
    console.log(arr);
    let formData = new FormData()
    formData.append("token",arr)

    setLoading(true);
    fetch(_host + "/josTools/checkTokenIsOverdue" , {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (res && res.code === 99999) {
          window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
        } else {
          setResult({
            ...res,
          });
          setTokenList(res.data)
        }
      })
      .catch(function () {
        console.log("失败了！！！");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderTokenList = (tokenList:any) => {
      let result: any = '';
      if(tokenList.code === -1){
        result = "该token无效～"
      }else if(tokenList.code === -2 ){
        result = "抱歉，您无权查询该token~"
      }else{
        result = <Table
        bordered
        dataSource={[tokenList]}
        columns={tokencolumns}
        pagination={false}
        />
      }
    return result
  }
  return (
    <div className={style.authQueryWrap}>
      <div className={style.desContentWrap}>
        <div className={style.desTitleWrap}>Token有效期查询工具使用说明：</div>
        <div className={style.desItemWrap}>1.为方便您快速查询您的应用被授权的有效期，特提供此工具。</div>
        <div className={style.desItemWrap}>2.此工具仅支持查询当前账号下的应用授权信息。</div>
      </div>
      <div className={style.formWrap}>
        <Spin spinning={loading}>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Token："
              name="token"
              rules={[
                {
                  required: true,
                  message: "请填写token~",
                }
              ]}
            >
              <Input placeholder={"请输入您要查询的token~"} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>

      <div style={{ display: show ? "block" : "none"  }}>
        <div className={style.desContentWrap}>
          <div className={style.YunDing}>查询结果</div>
        </div>
        <div className={style.TableToken}>
          {
            renderTokenList(tokenList)
          }
        </div>
      </div>
    </div>
  );
};

const LogQuery: FC<any> = () => {
  fetch(_host + "/josTools/manualAuth?appKey=1", {
    method: "GET",
    credentials: "include",
  })
  .then(function (response) {
    return response.json();
  })
  .then(function (res) {
    if (res.code === 99999) {
      window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
    }
  })
  const query = window.location.search;
  let queryList = {};
  if (query) {
    try {
      const tmp = query.slice(1).split("&");
      tmp.map((item) => {
        const arr = item.split("=");
        queryList[arr[0]] = arr[1];
      });
    } catch (error) {
      queryList = {};
    }
  }
  const url =  queryList["data"] ? '//open.jd.com/home/home/#/commonToolsLogDetail?data=' + queryList['data'] + '&origin=jos' : '//open.jd.com/home/home/#/commonToolsLog?origin=jos';
  return (
    <div className={style.authQueryWrap}>
      <iframe frameBorder="0" scrolling="auto" width="100%" height="800" src={url}></iframe>
    </div>
  );
};

const App: React.FC<IAppProps> = (props) => {
  const { apiHost, loginHost } = props;
  _host = apiHost;
  _loginHost = loginHost;

  const query = window.location.search;
  let queryList = {};
  if (query) {
    try {
      const tmp = query.slice(1).split("&");
      tmp.map((item) => {
        const arr = item.split("=");
        queryList[arr[0]] = arr[1];
      });
    } catch (error) {
      queryList = {};
    }
  }
  const id = queryList["id"] || 1;
  const selectKeys = [id.toString()];

  const title = titleMap[id];

  const crumbList = [
    {
      id,
      text: title,
    },
  ];
  return (
    <div className={style.commonToolsWrap}>
      {selectKeys && <LeftContentWrap selectKeys={selectKeys}></LeftContentWrap>}
      <MainContentWrapFc crumbList={crumbList} mainTitle={"常用工具"} hasRight={false} nameKey={"text"}>
        <div className={style.mainToolsWrap}>
          <h1>{title}</h1>
          {parseInt(id) === 1 && <Auth />}
          {parseInt(id) === 2 && <Sign />}
          {parseInt(id) === 3 && <AuthQuery />}
          {parseInt(id) === 4 && <YunQuery />}
          {parseInt(id) === 5 && <TokenQuery />}
          {parseInt(id) === 6 && <LogQuery />}
        </div>
      </MainContentWrapFc>
    </div>
  );
};

export default App;

